import { SVGProps } from 'react';

const ShareScaleMedium = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M20.7914 13.0203C21.0355 12.811 21.1575 12.7064 21.2023 12.5819C21.2415 12.4727 21.2415 12.3531 21.2023 12.2439C21.1575 12.1194 21.0355 12.0147 20.7914 11.8055L12.3206 4.54486C11.9004 4.18466 11.6903 4.00457 11.5124 4.00015C11.3578 3.99632 11.2101 4.06424 11.1124 4.18412C11 4.32205 11 4.59879 11 5.15226V9.44752C8.86532 9.82098 6.91159 10.9026 5.45971 12.5268C3.87682 14.2974 3.00123 16.5888 3 18.9639V19.5759C4.04934 18.3118 5.35951 17.2894 6.84076 16.5788C8.1467 15.9523 9.55842 15.5812 11 15.4834V19.6735C11 20.227 11 20.5037 11.1124 20.6417C11.2101 20.7615 11.3578 20.8295 11.5124 20.8256C11.6903 20.8212 11.9004 20.6411 12.3206 20.2809L20.7914 13.0203Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ShareScaleMedium;
